import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { URL_API } from "./url.api";
import { Path } from "../model/Path.model";
import { ReportMessageDTO } from "../model/ReportMessageDTO";

@Injectable({
    providedIn: 'root'
  })
  export class ReportService {

    constructor(
        private http: HttpClient
    ){}

    sendMailReport(message: ReportMessageDTO): Observable<any> {
        return this.http.post<any>(`${URL_API}/report/mail`, message);
    }

    findByFolder(folder: string): Observable<Array<Path>> {
        return this.http.get<Array<Path>>(`${URL_API}/report/paths/${folder}`);
    }

    controlePorData(data: Date, client: number, context: string): Observable<any> {
        return this.http.get<any>(`${URL_API}/report/controlePorData?data=${data}&cliente=${client}&context=${context}`);
    }

    controlePorDataPrint(data: Date, client: number): Observable<any> {
        return this.http.get<any>(`${URL_API}/report/controlePorDataPrint?data=${data}&cliente=${client}`);
    }
    
    consumoPorClienteEquip(dataIn: Date, dataFi: Date, client: number, context: string): Observable<any> {
        return this.http.get<any>(`${URL_API}/report/consumoPorClienteEquip?data_in=${dataIn}&data_fi=${dataFi}&cliente=${client}&context=${context}`);
    }

    consumoPorEquip(dataIn: Date, dataFi: Date, equipment: number, context: string): Observable<any> {
        return this.http.get<any>(`${URL_API}/report/consumoPorEquip?data_in=${dataIn}&data_fi=${dataFi}&equipamento=${equipment}&context=${context}`);
    }

    consumoPorSetorEquip(dataIn: Date, dataFi: Date, client: number, setor: number, context: string): Observable<any> {
        return this.http.get<any>(`${URL_API}/report/consumoPorSetorEquip?data_in=${dataIn}&data_fi=${dataFi}&cliente=${client}&setor=${setor}&context=${context}`);
    }

    produtoPorCliente(dataIn: Date, dataFi: Date, client: number, context: string): Observable<any> {
        return this.http.get<any>(`${URL_API}/report/produtoPorCliente?data_in=${dataIn}&data_fi=${dataFi}&cliente=${client}&context=${context}`);
    }
    
    produtoPorSetor(dataIn: Date, dataFi: Date, client: number, setor: number, context: string): Observable<any> {
        return this.http.get<any>(`${URL_API}/report/produtoPorSetor?data_in=${dataIn}&data_fi=${dataFi}&cliente=${client}&setor=${setor}&context=${context}`);
    }
    
    repContDataSetor(data: Date, setor: number, context: string): Observable<any> {
        return this.http.get<any>(`${URL_API}/report/repContDataSetor?data=${data}&setor=${setor}&context=${context}`);
    }

    repEquipPeriodo(dataIn: Date, dataFi: Date, equipment: number, context: string, order: string): Observable<any> {
        return this.http.get<any>(`${URL_API}/report/repEquipPeriodo?data_in=${dataIn}&data_fi=${dataFi}&equipamento=${equipment}&context=${context}&order=${order}`);
    }
   
    repEquipPeriodoXls(dataIn: Date, dataFi: Date, equipment: number, context: string, order: string): Observable<any> {
        return this.http.get<any>(`${URL_API}/report/repEquipPeriodoXls?data_in=${dataIn}&data_fi=${dataFi}&equipamento=${equipment}&context=${context}&order=${order}`);
    }

    controlePorDataXls(data: Date, client: number, context: string): Observable<any> {
        return this.http.get<any>(`${URL_API}/report/controlePorDataXls?data=${data}&cliente=${client}&context=${context}`);
    }

    repContDataSetorXls(data: Date, setor: number, context: string): Observable<any> {
        return this.http.get<any>(`${URL_API}/report/repContDataSetorXls?data=${data}&setor=${setor}&context=${context}`);
    }
   
    consumoPorClienteEquipXls(dataIn: Date, dataFi: Date, client: number, context: string): Observable<any> {
        return this.http.get<any>(`${URL_API}/report/consumoPorClienteEquipXls?data_in=${dataIn}&data_fi=${dataFi}&cliente=${client}&context=${context}`);
    }

    consumoPorSetorEquipXls(dataIn: Date, dataFi: Date, client: number, setor: number, context: string): Observable<any> {
        return this.http.get<any>(`${URL_API}/report/consumoPorSetorEquipXls?data_in=${dataIn}&data_fi=${dataFi}&cliente=${client}&setor=${setor}&context=${context}`);
    }
}